import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  FormLayout,
  Card,
  TextField,
  Select,
  InlineError,
  PageActions,
  Toast,
  Loading,
  Button,
  Collapsible,
  Spinner,
  Modal,
  Text,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

const AddEditDriver = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false
  );
  const [item, setItem] = useState({
    first_name: "",
    last_name: "",
    password: "",
    phone_number: "",
  });
  const handleChangeFirstName = (newValue) => {
    setItem({ ...item, first_name: newValue });
    setFirstNameError("");
  };
  const handleChangeLastName = (newValue) => {
    setItem({ ...item, last_name: newValue });
    setLastNameError("");
  };
  const handleChangePassword = (newValue) => {
    setItem({ ...item, password: newValue });
    setPasswordError("");
  };
  const handleChangePhone = (newValue) => {
    setItem({ ...item, phone_number: newValue });
    setPhoneError("");
  };
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;

  useEffect(() => {
    props.type === "edit" &&
      axios
        .get(`/drivers/${id}`)
        .then((result) => {
          setItem({
            first_name: result?.data?.data?.first_name
              ? result.data.data.first_name
              : "",
            last_name: result?.data?.data?.last_name
              ? result.data.data.last_name
              : "",
            phone_number: result?.data?.data?.phone_number
              ? result.data.data.phone_number
              : "",
            password: result?.data?.data?.password
              ? result.data.data.password
              : "",
          });
          setIsSaving(false);
        })

        .catch((err) => console.log(err));
  }, []);
  const [open, setOpen] = useState(false);
  const handleToggle = useCallback(() => setOpen((open) => !open), []);
  const refId = useRef(null);
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDelete = (id) => {
    refId.current = id;
    setActiveDelete(true);
  };
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/drivers/${id}`)
      .then((result) => {
        navigate("/admin/drivers");
      })
      .catch((err) => console.log(err));
  };
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} Driver`}
      backAction={{
        onAction: () => navigate("/admin/drivers"),
      }}
      narrowWidth
    >
      {isSaving ? <Loading /> : null}

      <Card>
        <FormLayout>
          <FormLayout.Group>
            <TextField
              label="First Name"
              value={item.first_name}
              onChange={handleChangeFirstName}
              error={firstNameError}
              requiredIndicator
            />
            <TextField
              value={item.last_name}
              onChange={handleChangeLastName}
              error={lastNameError}
              label="Last Name"
              requiredIndicator
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <TextField
              value={item.phone_number}
              onChange={handleChangePhone}
              error={phoneError}
              label="Phone Number"
              requiredIndicator
            />
            <TextField
              value={item.password}
              onChange={handleChangePassword}
              error={passwordError}
              label="Password"
              requiredIndicator
            />
          </FormLayout.Group>
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={
          <Button variant="primary" onClick={handleSave}>
            {isSaving ? <Spinner size="small" /> : "Save"}
          </Button>
        }
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              tone="critical"
              onClick={() => setActiveDelete(true)}
            >
              {isSaving ? <Spinner size="small" /> : "Delete"}
            </Button>
          )
        }
      />

      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Item"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <Text>
            <p>Are you sure you want to delete this item?</p>
          </Text>
        </Modal.Section>
      </Modal>
      {toastMarkup}
    </Page>
  );
  function handleSave() {
    if (
      !item.first_name ||
      !item.last_name ||
      !item.phone_number ||
      (!item.password && props.type === "add")
      // !isValidPhoneNumber(item.phone_number)
    ) {
      !item.first_name && setFirstNameError("This field is required");
      !item.last_name && setLastNameError("This field is required");
      !item.phone_number && setPhoneError("This field is required");
      !item.password &&
        props.type === "add" &&
        setPasswordError("This field is required");
      // !isValidPhoneNumber(item.phone_number) &&
      //   setPhoneError("Please enter a valid phone number");
    } else {
      setIsSaving(true);
      const bodyObj = {
        first_name: item.first_name,
        last_name: item.last_name,
        ...(item.password && { password: item.password }),
        phone_number: item.phone_number,
      };
      props.type === "add"
        ? axios
            .post(`/drivers`, bodyObj)
            .then((result) => {
              navigate("/admin/drivers");
            })
            .catch((error) => {
              setIsSaving(false);
              if (error.response) {
                setPasswordError(
                  <ul>
                    {error.response.data.errors.password.map(
                      (element, index) => {
                        return (
                          <div key={index}>
                            <h2>{element}</h2>
                          </div>
                        );
                      }
                    )}
                  </ul>
                );
              } else if (error.request) {
                console.log(error.request);
              } else {
                console.log("Error", error.message);
              }
            })
        : axios
            .patch(`/drivers/${id}`, bodyObj)
            .then((result) => {
              toggleActive();
              setIsSaving(false);
            })
            .catch((error) => {});
    }
  }
  function isValidPhoneNumber(phoneNumber) {
    const phoneRegex = /^[0-9]{10}$/;
    return phoneRegex.test(phoneNumber);
  }
};

export default AddEditDriver;
